import type { Virtualizer } from '@tanstack/react-virtual';
import clsx from "clsx";
import type { FunctionComponent, PropsWithChildren } from "react";

type TableBodyProps = PropsWithChildren & {
    horizontalBorders?: boolean;
    virtualized?: boolean;
    virtualizer?: Virtualizer<HTMLDivElement, Element>;
};

const TableBody: FunctionComponent<TableBodyProps> = ({
    children,
    horizontalBorders = true,
    virtualized = false,
}) => {
    // For virtualized tables, we don't use divide-y as it doesn't work well with dynamic rows
    // Instead, borders are handled in VirtualizedTableBodyContent
    return (
        <tbody className={clsx(
            "bg-inherit",
            horizontalBorders && !virtualized && "divide-y divide-gray-200"
        )}>
        {children}
        </tbody>
    );
};

export default TableBody;